module.exports = __webpack_public_path__ + "static/steelfort-ed0058be71cbe6a10ba0a0001983ea91.jpg";